import React, { useState} from "react";
import styles from './categorySelectionPanel.module.css';
import { GrCircleInformation } from "react-icons/gr";
import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';


function CategorySelectionPanel(){

  const [showInfo, setShowInfo] = useState("none");   //1, 2, 3, 4

  const {setIsAllSessionsClicked,  category, setCategoryFn, subject, setSubjectFn, setTopic} = useGlobalState();


  function handleIIconHover(category_number){
    setShowInfo(category_number);
  }

  function handleIIconOut(){
    setShowInfo("none");
  }

  
  return(
    <div className={styles.category_selection_panel_div}>
      <div name="discuss_and_learn" 
        onClick={() => {setCategoryFn("discuss_and_learn");
                        setIsAllSessionsClicked(prev => (prev===true)&&(!prev));
                      }} 
        className={(category==="discuss_and_learn")? styles.clicked_category: styles.category} 
      >
          <p className={styles.category_title}>Discuss and learn with a partner</p>
          <GrCircleInformation onMouseOver={() => handleIIconHover("1")} onMouseOut={handleIIconOut} className={styles.i_icon}/>
      </div>
      {(showInfo==="1")&&(<div className={styles.info_box_for_first_3_categories}>
                            <h1 className={styles.info_h1}>Instructions to use :</h1>
                            <h2 className={styles.info_h2}>The main purpose of "Discuss and learn with a partner" is to provide (pair) you with a person interested in the same topic as you so that you can discuss and learn things related to that subject ad-hoc. (75 minutes session)</h2>
                            <ul>
                              <li>Pin the subject you want to learn by searching for it from the search bar above the calendar.</li>
                              <li>Book a session (75 minutes) for a particular date and time slot from the subject calendar.</li>
                              <li>You will get a google calendar notification 1 hour before your session starts.</li>
                              <li>You can join the video call session 10 minutes before the session time. </li>
                              <li>Greet your partner! Tell him what task you will be working on. Ask what's his/her plan is for the session.</li>
                              <li>Focus on your task for the next 75 minutes. At the end of the session you will hear a bell at which point you can stop your work.</li>
                              <li>Ask if the other person has completed his/her task. Let him know if you have completed your tasks or update the person with the progress you have made.</li>
                              <li>Thank your partner or wish him luck! </li>
                            </ul>
                          </div>)}

      <div name="silent_study" 
        onClick={() => {setCategoryFn("silent_study");
                      setIsAllSessionsClicked(prev => (prev===true)&&(!prev));
                    }}      
        className={(category==="silent_study")? styles.clicked_category : styles.category } 
      >
          <p className={styles.category_title}>Silent study with a partner</p>
          <GrCircleInformation onMouseOver={() => handleIIconHover("2")} onMouseOut={handleIIconOut} className={styles.i_icon}/>
      </div>
      {(showInfo==="2")&&(<div className={styles.info_box_for_first_3_categories}>
                            <h1 className={styles.info_h1}>Instructions to use :</h1>
                            <h2 className={styles.info_h2}>The main purpose of "Silent study with a partner" is to provide (pair) you with an accountability/study buddy. (75 minutes session)</h2>
                            <ul>
                              <li>Book a session (75 minutes) for a particular date and time slot from the calendar.</li>
                              <li>You will get a google calendar notification 1 hour before your session starts.</li>
                              <li>You can join the video call session 10 minutes before the session time.</li>
                              <li>Greet your partner! Tell him what task you will be working on. Ask what's his/her plan is for the session.</li>
                              <li>Focus on your task for the next 75 minutes. At the end of the session you will hear a bell at which point you can stop your work.</li>
                              <li>Ask if the other person has completed his/her task. Let him know if you have completed your tasks or update the person with the progress you have made.</li>
                              <li>Thank your partner or wish him luck! </li>
                            </ul>
                          </div>)}
      
      
      {/* <div name="quick_doubt" 
        onClick={() => {setCategoryFn("quick_doubt")
                      setIsAllSessionsClicked(prev => (prev===true)&&(!prev));
              }} 
        className={(category==="quick_doubt")? styles.clicked_category : styles.category } 
      >
        <p className={styles.category_title}>Ask a quick doubt</p>
        <GrCircleInformation onMouseOver={() => handleIIconHover("3")} onMouseOut={handleIIconOut} className={styles.i_icon}/>
      </div> */}
      {(showInfo==="3")&&(<div className={styles.info_box_for_first_3_categories}>
                            <h1 className={styles.info_h1}>Instructions to use :</h1>
                            <h2 className={styles.info_h2}>The main purpose of "Ask a quick doubt" is to provide (pair) you with a person who is willing to clear your doubts in that particular subject. (25 minutes session)</h2>
                            <h2 className={styles.info_h2}>You can either ask doubts or clear other's doubts. While booking please select what option you would like to choose.</h2>
                            {/* <h2 className={styles.info_h2_red">The best part is, the person clearing the doubt will get paid $1 from Discusslearn for each satisfactory doubt clearance session! Share your wisdom and get paid!</h2> */}
                            <ul>
                              <li>Book a session by clicking on the time slot corresponding to the prefered date.</li>
                              <li>You will get a google calendar notification 1 hour before your session starts.</li>
                              <li>You can join the video call session 10 minutes before the session time. </li>
                              <li>Greet your partner! Tell him what task you will be working on. Ask him what his plan is for the session.</li>
                              <li>Focus on your task for the next 75 minutes. At the end of the session you will hear a bell at which point you can stop your work.</li>
                              <li>Ask if the other person has completed his/her task. Let him know if you have completed your tasks or update the person with the progress you have made.</li>
                              <li>Thank your partner or wish him luck! </li>
                            </ul>
                          </div>)}
      
      {/* <div name="learn_from_expert" 
        onClick={() => {setCategoryFn("learn_from_expert")
                      setIsAllSessionsClicked(prev => (prev===true)&&(!prev));
                  }}
        className={(category === "learn_from_expert" || category === "expert_schedule")? styles.clicked_category : styles.category} 
      >
        <p className={styles.category_title}>Learn live from an expert</p>
        <GrCircleInformation onMouseOver={() => handleIIconHover("4")} onMouseOut={handleIIconOut} className={styles.i_icon}/>
      </div> */}
      {(showInfo==="4")&&(<div className={styles.info_box_for_4th_category}>
                            <h1 className={styles.info_h1}>Instructions to use :</h1>
                            <h2 className={styles.info_h2}>The main purpose of "Learn live from an expert" is to provide you with an expert tutor in a particular subject who will take daily or weekly live classes to teach you the subject. (Class time, duration, frequency, price and number of people allowed per class is set by the tutor)</h2>
                            <h2 className={styles.info_h2_red}>The best part is, any one can teach live in this category and get paid monthly fees from their students. The only thing you need to do is earn "expert" title by spending your time in "Ask a Quick Doubt" category and clearing other user's doubts. If you get a satisfactory doubt clearance rate of 90 percentage or more you will be deemed as an expert and you can start teaching here. You set the monthly fees of your classes! Discusslearn will take a 20% share of that fees. Share your wisdom and get paid!</h2>
                            <ul>
                              <li>Book a session by clicking on the time slot corresponding to the prefered date.</li>
                              <li>You will get a google calendar notification 1 hour before your session starts.</li>
                              <li>You can join the video call session 10 minutes before the session time. </li>
                              <li>Greet your partner! Tell him what task you will be working on. Ask him what his plan is for the session.</li>
                              <li>Focus on your task for the next 75 minutes. At the end of the session you will hear a bell at which point you can stop your work.</li>
                              <li>Ask if the other person has completed his/her task. Let him know if you have completed your tasks or update the person with the progress you have made.</li>
                              <li>Thank your partner or wish him luck! </li>
                            </ul>
                          </div>)}
    
    </div>
  );
}

export default CategorySelectionPanel;